import { defineStore } from 'pinia';
import main from "@/api/main";
import profile from "@/api/profile";

var serverLocation = main.getServerLocation();
let api = profile.blobDomain[serverLocation];
export const useMindMapStore = defineStore('mindMap', {
    state: () => ({
        mindMapBlobsasurl: api + "/mindmap/",
        mindMapBlobContainerClient:"", 
        mindMapBlobSas: "",
    }),
    actions: {
        setMindMapBlobContainerClient(blobClient) {
            this.mindMapBlobContainerClient = blobClient;
        },

        setMindMapBlobSas(sas) {
            this.mindMapBlobSas = sas;
        }
    }
})